interface SectionHeaderProps {
  eyebrow: string;
  title: string;
}

export function SectionHeader({
  eyebrow,
  title,
}: SectionHeaderProps): JSX.Element {
  return (
    <div>
      <p className="text-cyan-500 tracking-wider font-semibold mb-2">{eyebrow}</p>
      <h2 className="text-3xl lg:text-4xl font-light">{title}</h2>
    </div>
  );
}
